import React from 'react';
import { Badge } from 'reactstrap';

const RenovatedBadgeField = ({ value, data, ...props }) => {
  let badgeText;
  let badgeClass;
  if (value == true) {
    badgeText = 'SI';
    badgeClass = 'master-yes';
  } else {
    badgeText = 'NO';
    badgeClass = 'master-no';
  }

  return (
    <div className={badgeClass} {...props}>
      <Badge>{badgeText}</Badge>
    </div>
  );
};

export default RenovatedBadgeField;
